import Button from '@/components/Button';
import clsx from '@/lib/clsx';
import { useRef, useEffect } from 'react';

const WizardYesOrNo = ({ value, onChange, autoFocus = false, label, description, className = '', ...props }) => {
  const yesButtonRef = useRef(null);

  useEffect(() => {
    if (autoFocus && yesButtonRef.current) {
      yesButtonRef.current.focus();
    }
  }, [autoFocus]);

  return (
    <div className={clsx('yes-or-no-container', (label || description) && 'with-label', description && 'has-description', className)} {...props}>
      {label && <div className="label">{label}</div>}
      {description && <div className="description">{description}</div>}
      <div className="yes-or-no-buttons">
        <Button ref={yesButtonRef} size="lg" className={clsx('outline', value === true && 'outline-active')} onClick={() => onChange(true)}>
          Yes
        </Button>
        <Button size="lg" className={clsx('outline', value === false && 'outline-active')} onClick={() => onChange(false)}>
          No
        </Button>
      </div>
    </div>
  );
};

export default WizardYesOrNo;
